module.exports = __webpack_public_path__ + "img/p2.ead36775.png";